/**
 * WithingsTokenPage - Route-Komponente für Token Tab
 * Wrapper um TokenTab mit Router-Integration
 */

import React from "react";

import { useWithingsData } from "../../hooks/useWithingsData";
import { TokenTab } from "./TokenTab";

export const WithingsTokenPage: React.FC = () => {
  const { isLoadingMeasurements } = useWithingsData();

  return <TokenTab isLoading={isLoadingMeasurements} />;
};
